type Props = {
  value: string;
  onChange: (value: string) => void;
};

export function FramingNoteInput({ value, onChange }: Props) {
  return (
    <div className="space-y-1">
      <label className="block text-sm font-medium" htmlFor="framing-note">
        Framing note (optional)
      </label>
      <p className="text-xs text-gray-500">
        Anything the photos can't show? E.g. <em>"Mia started initiating shared play this month — big shift from last month."</em>
      </p>
      <textarea
        id="framing-note"
        aria-label="Framing note"
        rows={3}
        className="block w-full border rounded px-2 py-1 text-sm"
        placeholder="A short observation about the month…"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
